export const unreachable = (value?: never): never => {
  throw new Error("This should never happen")
}
